<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
    
    <CSidebarBrand class="d-md-down-none" to="/">
      <b-img src="../sysped/logo.png" width="255px"/>      
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav"/>
    <p style="margin-left: 20px;">{{!minimize ? razaoSocial : ''}}</p>
    <h6 style="margin-left: 20px;">{{!minimize ? this.versaoShow : this.versaoMinimize}}</h6>
    <CSidebarMinimizer      
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'
import { version } from "../../package.json";
import settings from "@/settings";

export default {
  name: 'TheSidebar',
  nav,

  data() {
    return {
      versaoShow: "     Versão " + version,
      razaoSocial: "",
      versaoMinimize: version,
    }
  },

  mounted: function() {
    this.razaoSocial = settings.usuarioAutenticado.EMPRESA_NOME;
  },

  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
}
</script>
